import { isLocalPreviewHostname } from "../../config/localPreview";

const CLOUDFLARE_DEMO_HOSTNAME = "react-pgp-type.pages.dev";

function isCloudflareDemoHostname(hostname: string): boolean {
    const normalizedHostname = String(hostname || "").trim().toLowerCase();
    return normalizedHostname === CLOUDFLARE_DEMO_HOSTNAME
        || normalizedHostname.endsWith(`.${CLOUDFLARE_DEMO_HOSTNAME}`);
}

export function isPreviewDataAllowed({
    hostname = typeof window === "undefined" ? "" : window.location.hostname,
    mode = process.env.REACT_APP_MODE,
    nodeEnv = process.env.NODE_ENV,
    explicitFlag = process.env.REACT_APP_ENABLE_PREVIEW_DATA,
}: {
    hostname?: string;
    mode?: unknown;
    nodeEnv?: unknown;
    explicitFlag?: unknown;
} = {}): boolean {
    return String(nodeEnv || "").trim().toLowerCase() !== "production"
        && String(mode || "").trim().toUpperCase() === "LOCAL"
        && String(explicitFlag || "").trim().toLowerCase() === "true"
        && isLocalPreviewHostname(hostname);
}

export function assertPreviewDataAllowed(context = "preview data"): void {
    if (!isPreviewDataAllowed()) {
        throw new Error(`${context} is disabled outside an explicit local development preview.`);
    }
}

export function isPasswordlessDemoLoginAllowed({
    hostname = typeof window === "undefined" ? "" : window.location.hostname,
    mode = process.env.REACT_APP_MODE,
    nodeEnv = process.env.NODE_ENV,
    previewDataFlag = process.env.REACT_APP_ENABLE_PREVIEW_DATA,
    passwordlessFlag = process.env.REACT_APP_ENABLE_PASSWORDLESS_DEMO_LOGIN,
}: {
    hostname?: string;
    mode?: unknown;
    nodeEnv?: unknown;
    previewDataFlag?: unknown;
    passwordlessFlag?: unknown;
} = {}): boolean {
    if (isPreviewDataAllowed({
        hostname,
        mode,
        nodeEnv,
        explicitFlag: previewDataFlag,
    })) {
        return true;
    }

    return String(mode || "").trim().toUpperCase() === "LOCAL"
        && String(passwordlessFlag || "").trim().toLowerCase() === "true"
        && isCloudflareDemoHostname(hostname);
}

export function isDemoContentAllowed({
    hostname = typeof window === "undefined" ? "" : window.location.hostname,
    mode = process.env.REACT_APP_MODE,
    nodeEnv = process.env.NODE_ENV,
    previewDataFlag = process.env.REACT_APP_ENABLE_PREVIEW_DATA,
    demoContentFlag = process.env.REACT_APP_ENABLE_DEMO_CONTENT,
}: {
    hostname?: string;
    mode?: unknown;
    nodeEnv?: unknown;
    previewDataFlag?: unknown;
    demoContentFlag?: unknown;
} = {}): boolean {
    if (isPreviewDataAllowed({
        hostname,
        mode,
        nodeEnv,
        explicitFlag: previewDataFlag,
    })) {
        return true;
    }

    return String(mode || "").trim().toUpperCase() === "LOCAL"
        && String(demoContentFlag || "").trim().toLowerCase() === "true"
        && isCloudflareDemoHostname(hostname);
}

// A public demo marker is not an authenticated customer token. Keep it out of
// live API calls; localhost's separately configured read-only preview is unchanged.
export function isPublicPasswordlessDemoSession({
    token,
    hostname = typeof window === "undefined" ? "" : window.location.hostname,
    mode = process.env.REACT_APP_MODE,
    passwordlessFlag = process.env.REACT_APP_ENABLE_PASSWORDLESS_DEMO_LOGIN,
}: {
    token: unknown;
    hostname?: string;
    mode?: unknown;
    passwordlessFlag?: unknown;
}): boolean {
    return String(token || "").trim() === "preview"
        && isCloudflareDemoHostname(hostname)
        && isPasswordlessDemoLoginAllowed({ hostname, mode, passwordlessFlag });
}
